/** Index of the x in `xs` closest to `x`; the earlier one wins a tie. */
export function nearestIndex(xs: number[], x: number): number {
  let best = 0;
  xs.forEach((value, i) => {
    if (Math.abs(value - x) < Math.abs(xs[best] - x)) best = i;
  });
  return best;
}

const GAP = 12;

/**
 * Where a tooltip of `size` goes beside a vertical line at `at.x`: to its right
 * in the left half of `box` and to its left in the right half, so it never
 * covers the line, centred on `at.y` and kept inside `box`.
 */
export function placeTooltip(
  at: { x: number; y: number },
  size: { width: number; height: number },
  box: { width: number; height: number },
): { left: number; top: number } {
  const left = at.x <= box.width / 2 ? at.x + GAP : at.x - GAP - size.width;
  const top = at.y - size.height / 2;
  return {
    left: Math.max(0, Math.min(left, box.width - size.width)),
    top: Math.max(0, Math.min(top, box.height - size.height)),
  };
}

/** A point as a screen reader hears it: "Mayo. Ingresos: $1. Gastos: $2". */
export const describePoint = (title: string, rows: { label: string; value: string }[]) =>
  [title, ...rows.map((row) => `${row.label}: ${row.value}`)].join('. ');
